import React from "react";
import usePersistedState from "../../../hooks/usePersistedState";
import { useStore } from "../../../store/store";

function useSwingDirectionSelector(submitPressed: boolean, editQuote: boolean) {
  const addToQuote = useStore((state) => state.addToQuote);

  const editBtn = useStore((state) => state.isEdit);

  const direction = useStore((state) => state.quote.swingDirection);
  const sType = useStore((state) => state.quote.swingType);
  const sLite = useStore((state) => state.quote.sideLite);

  const material = useStore((state) => state.quote.material);
  const isAlum = material?.includes("Aluminum")

  const handleErrMsgChange = useStore((state) => state.handleError);

  const handleClickSDir = (label: string) => {
    const checked = label === direction;

    if (checked) return;

    addToQuote({
      swingDirection: label,
      swingType: "",
      sideLite: "none",
      sillStyle: label === "Outswing" ? "Outswing Sill" : "Inswing Sill",
      exactConfig: "",
      exactConfigImg: "",
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
      unitSize: "",
      unitSizeFraction: "",
      swingPanelWidth: "",
      swingPanelFraction: "",
      equalPanels: false,
    });

    handleErrMsgChange("sideliteWidthErr", "");
    handleErrMsgChange("jambErr", "");
  };

  const handleClickSType = (label: string) => {
    const checked = label === sType;

    if (checked) return;

    addToQuote({
      swingType: label,
      sideLite: "none",
      equalPanels: false,
      exactConfigImg: "",
      exactConfig: "",
    });

    handleErrMsgChange("widthErr", "");
    handleErrMsgChange("sideliteWidthErr", "");
  };

  const handleClickSLite = (label: string) => {
    const checked = label === sLite;

    if (checked) {
      addToQuote(
        {
          equalPanels: false,
          sideLite: "none",
          exactConfig: "",
        },
        "sideLite"
      );
    } else {
      addToQuote(
        {
          exactConfigImg: "",
          sideLite: label,
          exactConfig: "",
        },
        "sideLite"
      );
    }

    handleErrMsgChange("widthErr", "");
    handleErrMsgChange("sideliteWidthErr", "");
  };

  const [widthMeasureImg, setWidthMeasureImg] = usePersistedState(
    "widthMeasureImg",
    "",
    submitPressed,
    editQuote
  );

  return {
    widthMeasureImg,
    setWidthMeasureImg,
    handleClickSLite,
    handleClickSType,
    handleClickSDir,
    editBtn,
    direction,
    sType,
    sLite,
    isAlum
  };
}

export default useSwingDirectionSelector;
